<template lang="html">
  <component :is="tag" class="">
    <a href="#" class="editable-a" v-show="!editing" @click.prevent="edit">
      <span v-if="type === 'date'">{{ value | date }}</span>
      <span v-if="type === 'text'">{{ value }}</span>
      <span v-if="type === 'currency'">{{ value | currency }}</span>
      <span v-if="type === 'phone'">{{ value | telefone }}</span>
      <span v-if="type === 'cpf'">{{ value | cpfCnpj }}</span>
      <span v-if="type === 'cnpj'">{{ value | cpfCnpj }}</span>
      <span v-if="type === 'cep'">{{ value }}</span>
      <span v-if="type === 'number'">{{ value }}</span>
      <i class="fa fa-pencil icon-black"></i>
    </a>
    <div class="input-group" v-show="editing">
      <input-data v-if="type === 'date'" v-model="model" @on-enter="onSave" />
      <input
        v-if="type === 'text'"
        type="text"
        class="form-control"
        v-model="model"
        @keyup.enter="onSave"
      />
      <input-money v-if="type === 'currency'" v-model="model" @on-enter="onSave" />
      <input-telefone v-if="type === 'phone'" v-model="model" @on-enter="onSave" />
      <input-cpf v-if="type === 'cpf'" v-model="model" @on-enter="onSave" />
      <input-cnpj v-if="type === 'cnpj'" v-model="model" @on-enter="onSave" />
      <input-cep v-if="type === 'cep'" v-model="model" @on-enter="onSave" />
      <input
        v-if="type === 'number'"
        type="number"
        class="form-control"
        v-model="model"
        @keyup.enter="onSave"
      />
      <span class="input-group-btn">
        <button type="button" class="btn btn-primary" @click.prevent="onSave">
          <i class="fa fa-floppy-o"></i>
        </button>
        <button type="button" class="btn btn-danger" @click.prevent="onCancel">
          <i class="fa fa-times"></i>
        </button>
      </span>
    </div>
  </component>
</template>

<script>
import InputData from '../../components/Inputs/InputData.vue'
import InputMoney from '../../components/Inputs/InputMoney.vue'
import InputTelefone from '../../components/Inputs/InputTelefone.vue'
import InputCpf from '../../components/Inputs/InputCpf.vue'
import InputCnpj from '../../components/Inputs/InputCnpj.vue'
import InputCep from '../../components/Inputs/InputCep.vue'

export default {
  name: 'input-editable',
  data() {
    return {
      editing: false,
      model: ''
    }
  },
  props: {
    value: {
      required: true
    },
    type: {
      required: true,
      type: String
    },
    tag: { typr: String, default: 'div' }
  },
  mounted() {
    this.model = this.value
  },
  methods: {
    onSave() {
      this.editing = false
      this.$emit('on-save', this.model)
    },

    onCancel() {
      this.editing = false
      this.model = this.value
    },

    edit() {
      this.editing = true
      this.cancelAll()
      setTimeout(() => {
        this.$el.querySelector('input').focus()
        this.$el.querySelector('input').select()
      }, 100)
    },

    cancelAll() {
      const componentId = this._uid
      const editables = this.$parent.$children.filter(
        x => x._uid !== componentId && x.$options.name === this.$options.name
      )
      for (let editable of editables) {
        editable.onCancel()
      }
    }
  },
  components: {
    InputData,
    InputMoney,
    InputTelefone,
    InputCpf,
    InputCnpj,
    InputCep
  },
  watch: {
    value(vl) {
      this.model = vl
    }
  }
}
</script>

<style lang="css" scoped>
.editable-a {
  border-bottom: 1px dotted #000;
}

.icon-black {
  color: #000;
}
</style>
